import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { NgModule } from '@angular/core';
import { RxButtonModule } from '@nrwl/rx-button';
import { RxColModule } from '@nrwl/rx-col';
import { RxDialogComponent } from './rx-dialog.component';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxRowModule } from '../rx-row/rx-row.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    RxColModule,
    RxRowModule,
    RxIconModule,
    RxButtonModule,
    RxDialogComponent,
  ],
  exports: [RxDialogComponent],
})
export class RxDialogModule {}
